import React from 'react';

import GuidedPracticeList from './Containers/GuidedPracticeList';

const GuidedPractice = () => {
  return <GuidedPracticeList />;
};

export default GuidedPractice;
